<div class="img-wrapper" [ngStyle]="{width: width, height: width}"
	[ngClass]="{square: type === 'square', circle: type === 'circle'}">
	<img [imgPreloader]="src" [attr.alt]="alt">
</div>